export default __webpack_public_path__ + "static/media/portfolio-generator.0ea07364.png";